<template>
  <div class="trt-column">
    <div class="trt-column-header">
      <span class="trt-column-accent" :style="{ backgroundColor: column.accent }"></span>
      <div class="trt-column-heading">
        <span class="trt-column-label">{{ column.label }}</span>
        <span v-if="column.description" class="trt-column-desc">{{ column.description }}</span>
      </div>
      <span class="trt-column-count">{{ records.length }}</span>
    </div>

    <div class="trt-column-body">
      <TRTPatientCard
        v-for="record in records"
        :key="record.trtPatientId"
        :record="record"
        @edit-monitor-date="$emit('edit-monitor-date', $event)"
      />
      <p v-if="records.length === 0" class="trt-column-empty">None</p>
    </div>
  </div>
</template>

<script>
import TRTPatientCard from './TRTPatientCard.vue';

export default {
  name: 'TRTBoardColumn',
  components: { TRTPatientCard },
  props: {
    column: {
      type: Object,
      required: true
    },
    records: {
      type: Array,
      required: true
    }
  },
  emits: ['edit-monitor-date']
};
</script>

<style scoped>
.trt-column {
  display: flex;
  flex-direction: column;
  width: 360px;
  min-width: 360px;
  background-color: var(--content-header-bg);
  border: 1px solid #e0e0e0;
  border-radius: var(--border-radius);
}

.trt-column-header {
  display: flex;
  align-items: flex-start;
  gap: 8px;
  padding: 10px 12px;
  border-bottom: 1px solid #e0e0e0;
}

.trt-column-accent {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  flex-shrink: 0;
  margin-top: 3px;
}

.trt-column-heading {
  display: flex;
  flex-direction: column;
  gap: 2px;
  flex: 1;
  min-width: 0;
}

.trt-column-label {
  font-size: 11px;
  font-weight: 600;
  color: #525252;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.trt-column-desc {
  font-size: 10px;
  color: #9ca3af;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.trt-column-count {
  font-size: 11px;
  font-weight: 600;
  color: #6b7280;
  background-color: #eceef0;
  border-radius: var(--border-radius);
  padding: 1px 7px;
  min-width: 20px;
  text-align: center;
}

.trt-column-body {
  display: flex;
  flex-direction: column;
  gap: 10px;
  padding: 10px;
}

.trt-column-empty {
  margin: 8px 0;
  text-align: center;
  font-size: 13px;
  color: #9ca3af;
  font-style: italic;
}
</style>
